import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Card, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { WHITE, GRAY_500 } from "../constant/colors";
import { NotificationSettingsIcon } from "../assets/svg/NotificationSettingsIcon";
import { SettingsIcon } from "../assets/svg/SettingsIcon";
import { selectUser, selectEnvironment } from "../store/selector";
import { trackPendoEvent } from "../utils/pendo/pendoUtils";

const { Text } = Typography;

const SettingsScreen = styled.div`
  width: 98%;
  margin: 0 auto;
  padding: 12px;
  background: ${WHITE};
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const HeaderSection = styled.div`
  flex-shrink: 0;
  padding: 8px 4px;
`;

const BreadcrumbSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 16px;
`;

const BreadcrumbCurrent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 600;
  color: #000000;
`;

const PageDescription = styled(Text)`
  font-size: 14px;
  color: ${GRAY_500};
  display: block;
  margin-bottom: 24px;
`;

const NotificationSettingsCard = styled(Card)`
  border-radius: 10px;
  border: 1px solid ${GRAY_500};
  cursor: pointer;
  transition: all 0.2s;
  width: 346px;
  height: 108px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .ant-card-body {
    padding: 24px;
    height: 100%;
    display: flex;
    align-items: center;
  }
`;

const NotificationIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 16px;
  width: 39.81px;
  height: 39.43px;
`;

const SettingsComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const account = useSelector(selectEnvironment);

  const handleNotificationSettingsClick = () => {
    try {
      trackPendoEvent(dispatch, "Settings_Notification_Preferences", {
        username: user?.email,
        account
      });
    } catch (error) {
      console.error("Error dispatching settings Pendo event:", error);
    }
  };

  return (
    <SettingsScreen>
      <HeaderSection>
        <BreadcrumbSection>
          <BreadcrumbCurrent>
            <SettingsIcon />
            Settings
          </BreadcrumbCurrent>
        </BreadcrumbSection>
        <PageDescription>{t("settings.subtitle")}</PageDescription>
      </HeaderSection>

      <Link to="/notification-preferences" style={{ textDecoration: "none" }} onClick={handleNotificationSettingsClick}>
        <NotificationSettingsCard id="Settings_Notification_Preferences">
          <Row align="middle">
            <Col>
              <NotificationIcon>
                <NotificationSettingsIcon width="39.81px" height="39.43px" />
              </NotificationIcon>
            </Col>
            <Col flex="1">
              <Typography.Title level={4} style={{ margin: 0, marginBottom: 1 }}>
                {t("settings.notification_settings_title")}
              </Typography.Title>
              <Typography.Text type="secondary">{t("settings.notification_settings_description")}</Typography.Text>
            </Col>
          </Row>
        </NotificationSettingsCard>
      </Link>
    </SettingsScreen>
  );
};

export { SettingsComponent as Settings };
